import { Grid } from "@mui/material";
import Spinner from "components/common/Spinner/Spinner";
import Typography from "components/common/Typography";
import Cards from "components/features/library/libraryHall/cards/Cards";
import { useNavigate } from "react-router-dom";
import { missingIncodeText } from "utils/CommonConstants";
import { useAppSelector } from "../../../../redux/hooks";
import SearchAppBar from "../../../common/searchBar";
import "./index.scss";

function Index() {
  const navigate = useNavigate();
  const FunctionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const isLoading: any = useAppSelector((state) => state.functionalAreas.status) === "loading";
  const bookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const backURL = "/library";
  const getInputDetails = (inputText: string) => {
    if (inputText.length > 2) navigate(`/library/search?q=${inputText}`, { state: { backURL: backURL } });
  };

  if (isLoading) {
    return <Spinner backdropVisible />;
  }

  return (
    <>
      {isAdmin && (
        <>
          {bookMarkInncodes && bookMarkInncodes.length === 0 && innCode === missingIncodeText && (
            <Typography
              textAlign={"center"}
              sx={{
                mt: 5
              }}
              variant={"h4"}
              children={"You do not have any bookmarked Inncodes"}
              showBold
            ></Typography>
          )}
          {innCode !== missingIncodeText && (
            <>
              <Grid container marginY={"30px"} marginX="auto" sx={{ width: { xs: "100%", md: "462px" } }}>
                <Grid item xs={12}>
                  <SearchAppBar getInputDetails={getInputDetails} divider></SearchAppBar>
                </Grid>
              </Grid>
              <Cards label1="Explore by " label2="functional area" list={FunctionalAreaList} />
            </>
          )}
        </>
      )}
      {!isAdmin && (
        <>
          <Grid container marginY={"30px"} marginX="auto" sx={{ width: { xs: "100%", md: "462px" } }}>
            <Grid item xs={12}>
              <SearchAppBar getInputDetails={getInputDetails} divider></SearchAppBar>
            </Grid>
          </Grid>
          <Cards label1="Explore by " label2="functional area" list={FunctionalAreaList} />
        </>
      )}
    </>
  );
}

export default Index;
